import ActionTypes from '@ziynx/action-types';

type AdminActions = {
  type: string,
  id: string,
}

const initialState = {
  fetching: false,
};

export default function reduceTalentScorecardValues(state = initialState, action: AdminActions) {
  if (!action.type) {
    return state;
  }

  switch (action.type) {
  case ActionTypes.admin.getTalentScorecardValues.START:
    return {
      ...state,
      fetching: true,
    };

  case ActionTypes.admin.getTalentScorecardValues.SUCCESS:
    return {
      ...state,
      ...action?.response,
      fetching: false,
    };

  case ActionTypes.admin.getTalentScorecardValues.ERROR:
    return {
      ...state,
      ...action?.response,
      fetching: false,
    };

  default:
    return state;
  }
}
